
import React, { useEffect, useState } from "react";
import { fetchFoodMenu } from "./FoodMenuQuery";
import "./FoodMenu.css";
import bgImage from "../../assets/foodmenu-bg.png"; 

const BASE_URL = process.env.REACT_APP_CMS_BASE_URL;

const getUrl = (pathArray) => {
  if (!pathArray || pathArray.length === 0) return "";
  const path = pathArray[0];
  return path.startsWith("http")
    ? encodeURI(path)
    : encodeURI(`${BASE_URL}${path}`);
};

const FoodMenu = ({ setNavbarBg }) => {
  const [menuData, setMenuData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadMenu() {
      try {
        const data = await fetchFoodMenu();
        const page = data?.menupage?.[0];

        setMenuData(page || null);
      } catch (err) {
        console.error("FoodMenu fetch error:", err);
      } finally {
        setLoading(false);
      }
    }

    loadMenu();
  }, []);

  
  useEffect(() => {
    if (setNavbarBg) {
      setNavbarBg(`url(${bgImage})`);
    }
  }, [setNavbarBg]);

 // if (loading) return <p>Loading menu...</p>;
  if (!menuData) return <p>Error loading menu</p>;

  const title = menuData.cafegpSignatureTitle;
  const items =
    menuData.foodSection?.contentItems?.filter((item) => item.enabled) || [];

  return (
    <section
      className="foodmenu-section"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="foodmenu-overlay">
        <h2 className="foodmenu-title">{title}</h2>

        <div className="foodmenu-grid">
          {items.map((item, index) => {
            const imgUrl = getUrl(item.foodItemImage?.urls);
            const rotation = item.imageAllignmentWithPlane?.includes("-")
              ? "10deg"
              : "-10deg";

            return (
              <div
                className="foodmenu-card"
                key={index}
                style={{ transform: `rotate(${rotation})` }}
              >
                <div className="foodmenu-img-wrapper">
                  <img
                    src={imgUrl}
                    alt={item.foodItemName}
                    className="foodmenu-img"
                  />
                  <span className="line top"></span>
                  <span className="line bottom"></span>
                  <span className="line left"></span>
                  <span className="line right"></span>
                </div>
                <p className="foodmenu-name">{item.foodItemName}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FoodMenu;
